<template>
  <div class="box">
    <!-- <img src="../../assets/images/icons/loader.gif" alt="" /> -->
    <img src="../../assets/images/icons/mainLoader.gif" alt="" />
  </div>
</template>

<script>
export default {
  name: 'mainLoader',

  props: ['ChartType'],

  data() {
    return {}
  },

  created() {},
}
</script>
